import React from 'react';

import { Flex } from '@chakra-ui/react';
import { themeColors } from 'themes/clients/baseTheme';

import { CheckCircle, ThumbsUpGenAi, ThumbsDownGenAi } from 'assets/assetsV1/iconComponents';

import { Button } from 'uiToolkitV1/Button';
import { Tooltip } from 'uiToolkitV1/Tooltip';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

const FeedbackStatuses = { NEUTRAL: 'USE', LIKED: 'LIKE', DISLIKED: 'DISLIKE' };

function FeedbackComponent({ curFeedbackStatus, setCurFeedbackStatus = () => {}, onChange = () => {} }) {
  const isFeedbackTaken = Boolean(curFeedbackStatus);
  return (
    <Flex justify="space-between" width="100%" alignItems="center">
      {isFeedbackTaken ? (
        <Flex width="100%" alignItems="center" py="8px">
          <CheckCircle color="#44812F" />
          <TextBodyMedium color="#44812F" ml="4px">
            Thank you! Your response will help us improve Maven
          </TextBodyMedium>{' '}
        </Flex>
      ) : (
        <>
          <TextBodyMedium>Did you like my response?</TextBodyMedium>
          <Flex>
            <Tooltip label="Like">
              <Button
                EndIcon={ThumbsUpGenAi}
                endIconProps={{
                  color: themeColors.button.blue.default,
                }}
                svgHoverColor={themeColors.button.blue.default}
                onClick={() => {
                  setCurFeedbackStatus(FeedbackStatuses.LIKED);
                  onChange(FeedbackStatuses.LIKED);
                }}
                background="transparent !important"
              />
            </Tooltip>

            <Tooltip label="Dislike">
              <Button
                EndIcon={ThumbsDownGenAi}
                endIconProps={{
                  color: themeColors.button.blue.default,
                }}
                svgHoverColor={themeColors.button.blue.default}
                onClick={() => {
                  setCurFeedbackStatus(FeedbackStatuses.DISLIKED);
                  onChange(FeedbackStatuses.DISLIKED);
                }}
                background="transparent !important"
                ml="10px"
              />
            </Tooltip>
          </Flex>
        </>
      )}
    </Flex>
  );
}

export default FeedbackComponent;
